export default "__VITE_ASSET__4bZE4fSI__"